import React from "react";
import { footerVatDetails } from "../../../common/constant";
import ContentModule from "../../../modules/content_module";

const FooterText = () => {
    return (
        <>
        {footerVatDetails && 
            <div class="footer_text"><ContentModule Content={footerVatDetails} /></div>
        }
        </>
    )
}
export default FooterText;